module.exports = __webpack_public_path__ + "img/blind-box1.267d2438.png";